export const excelColumnHead = () => {
  let list = []
  for (let i = 0; i < 26; i++) {
    list.push(String.fromCharCode(65 + i))
  }
  for (let i = 0; i < 26; i++) {
    list.push('A' + String.fromCharCode(65 + i))
  }
  return list
};

export const exportSetting = (headData, bodyData, tableTheadData, titleText) => {
  let exportData = [];
  // ------------------------- 合并单元格算法计算
  let excelColHead = excelColumnHead();
  // 表格左上角固定的两行、两列
  let makeMerger = [
    ['A1', 'A2'],
    ['B1', 'B2'],
  ];
  let colIndexStart = 1;
  let colIndexEnd = 2;
  let num = 2;
  headData[1].splice(0, 0, '', ''); // 表头第二行添加序号列，内容为空白
  tableTheadData.forEach((obj, index) => {
    let periods = obj.periods;
    if (periods && periods.length > 0) {
      colIndexStart++;
      colIndexEnd = colIndexStart + periods.length - 1;
      makeMerger.push([excelColHead[colIndexStart] + '1', excelColHead[colIndexEnd] + '1']);
      colIndexStart = colIndexEnd;

      for (let j = 0; j < periods.length - 1; j++) {
        headData[0].splice(index + num, 0, '');
        num++;
      }
    }
  });
  // 添加数据
  exportData.push.apply(exportData, headData);
  exportData.push.apply(exportData, bodyData);
  // 样式设置
  LAY_EXCEL.setExportCellStyle(exportData, `A1:${excelColHead[colIndexEnd] + (headData.length + bodyData.length)}`, {
    s: {
      alignment: {
        horizontal: 'center',
        vertical: 'center',
      },
      border: {
        top: { style: 'thin', color: { rgb: '00000000' } },
        bottom: { style: 'thin', color: { rgb: '00000000' } },
        left: { style: 'thin', color: { rgb: '00000000' } },
        right: { style: 'thin', color: { rgb: '00000000' } },
      },
      font: { name: 'arial', sz: 10 },
    },
  });
  // 表头添加样式
  LAY_EXCEL.setExportCellStyle(exportData, `A1:${excelColHead[colIndexEnd] + headData.length}`, {
    s: {
      alignment: {
        horizontal: 'center',
        vertical: 'center',
      },
      border: {
        top: { style: 'thin', color: { rgb: '00000000' } },
        bottom: { style: 'thin', color: { rgb: '00000000' } },
        left: { style: 'thin', color: { rgb: '00000000' } },
        right: { style: 'thin', color: { rgb: '00000000' } },
      },
      font: { bold: true, name: 'arial', sz: 12 },
      fill: { bgColor: { indexed: 64 }, fgColor: { rgb: 'c0c0c0' } },
    },
  });

  // 计算列宽、行高
  let colConfObj = {};
  let rowConfObj = {};
  headData.forEach((v, i) => {
    rowConfObj[i + 1] = 25;
    if (i == 0) {
      v.forEach((m, j) => {
        colConfObj[excelColHead[j]] = 90;
      });
    }
  });
  bodyData.forEach((v, i) => {
    rowConfObj[headData.length + i + 1] = 22;
  });
  // 设置列宽
  let colConf = LAY_EXCEL.makeColConfig(colConfObj, 90);
  // 设置行高
  let rowConf = LAY_EXCEL.makeRowConfig(rowConfObj, 24);
  // 合并单元格设置
  let mergeConf = LAY_EXCEL.makeMergeConfig(makeMerger);
  // console.log(tableTheadData.value, headData);
  // 数据导出
  LAY_EXCEL.exportExcel(exportData, `${titleText}.xlsx`, 'xlsx', { extend: { '!merges': mergeConf, '!cols': colConf, '!rows': rowConf } });

}

export const treeAddCrumbs = (arr, crumbs, ndAndjd) => {
  arr.forEach(v => {
    v.crumbs = crumbs + ',' + v.nodeName
    v.id = v.nodeId;
    v.nodeId = v.nodeId + '-' + ndAndjd
    if (v.children && v.children.length > 0) treeAddCrumbs(v.children, v.crumbs, ndAndjd)
  });
}

/**
 *
 * @param {*} arr
 * @returns array
 */
export const getTreeDefaultActive = (arr) => {
  if (arr.length > 0) {
    if (arr[0].children && arr[0].children.length > 0) return getTreeDefaultActive(arr[0].children);
    else return arr[0];
  } else return '';
};

export const fillterName = (arr, str, colname) => {
  let name = '';
  arr.forEach(v => {
    if (v.colStr == str) name = v[colname]
  });
  return name
}
